import PropTypes from 'prop-types';

import styles from './ResolutionLayout.module.scss';

const ResolutionLayout = ({ children }) => (
  <section className={styles.resolutionLayout}>{children}</section>
);

ResolutionLayout.propTypes = {
  children: PropTypes.node,
};

ResolutionLayout.defaultProps = {
  children: <div />,
};

export default ResolutionLayout;
